export const blockIconsSocialThumbUpAlt = (
	<span className='material-symbols-outlined'>thumb_up_alt</span>
);
